module.exports = __webpack_public_path__ + "img/优势@2x.8a4b1615.png";